import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=f2ac2450&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"
import style0 from "./home-page.vue?vue&type=style&index=0&id=f2ac2450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ac2450",
  null
  
)

export default component.exports